import { Component, ElementRef, ViewChild } from '@angular/core';
import { BlockFeedback } from '@src/app/@shared/models/step.model';
import { AbstractControl, FormBuilder, FormControl } from '@angular/forms';
import { BlockAbstractComponent } from '@app/components/blocks/block.abstract.component';
import { FeedbackValue } from '@app/components/feedback/feedback.component';

export enum FormControlName {
  feedback = 'feedback',
}

interface FeedbackForm {
  [FormControlName.feedback]: FormControl<FeedbackValue>;
}

@Component({
  selector: 'pl-block-feedback',
  templateUrl: './block-feedback.component.html',
})
export class BlockFeedbackComponent extends BlockAbstractComponent<BlockFeedback, FeedbackForm> {
  protected FormControlName: typeof FormControlName = FormControlName;

  @ViewChild('plFeedback', { read: ElementRef }) public plFeedbackElement!: ElementRef;

  protected override initForm(): void {
    const fb: FormBuilder = new FormBuilder();
    this.form = fb.nonNullable.group<FeedbackForm>({
      feedback: fb.nonNullable.control({
        ratingValue: null,
        feedbackText: null,
      }),
    });
  }

  protected override patchFormWithEmptyValue(): void {
    if (this.form) {
      this.form.patchValue(
        {
          feedback: {
            ratingValue: null,
            feedbackText: null,
          },
        },
        { emitEvent: false },
      );
    } else {
      throw new Error(`patchFormWithEmptyValue() this.form should not be null when this function is called`);
    }
  }

  protected override patchFormFromBlock(block: BlockFeedback): void {
    if (this.form) {
      this.form.patchValue(
        {
          feedback: {
            ratingValue: block.data.rating_value,
            feedbackText: block.data.feedback_text,
          },
        },
        { emitEvent: false },
      );
    } else {
      throw new Error(`patchFormFromBlock() this.form should not be null when this function is called`);
    }
  }

  protected override getUpdatedBlock(): BlockFeedback {
    if (this.form && this.block) {
      const control: AbstractControl | null = this.form.get(FormControlName.feedback);
      if (control) {
        return {
          ...this.block,
          data: {
            ...this.block.data,
            rating_value: control.value.ratingValue,
            feedback_text: control.value.feedbackText,
          },
        };
      }
    }

    throw new Error(`getUpdatedBlock() this.form or control should not be null when this function is called`);
  }

  protected override onProgrammaticFocus(): void {
    // preventScroll: true because scroll is handled by directive plScrollToInvalidControlOnSubmit
    this.plFeedbackElement.nativeElement.focus({ preventScroll: true });
  }
}
